import React, { useState, useEffect } from "react";
import UserLogsList from "./UserLogsList";
import FileUploadLogsList from "./FileUploadLogsList";
import useGetAuditLog from "../application/Hooks/useGetAuditLog";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format, parse } from "date-fns"; // You'll need to install date-fns

const UserLogs = ({ companyId, auditLogRequest, setAuditLogRequest }) => {
  const [error1, setError1] = useState("");
  const [activeTab, setActiveTab] = useState("");

  const { getAuditLogs, auditLogs, isLoading } = useGetAuditLog();

  const validateDates = () => {
    if (!auditLogRequest.fromDate || !auditLogRequest.toDate) {
      setError1(
        `Please enter ${!auditLogRequest.fromDate ? "Start Date" : "End Date"}.`
      );
      return false;
    }
    setError1(""); // Clear error if validation passes
    return true;
  };

  const getUserLogs = async (e) => {
    e.preventDefault();
    if (!validateDates()) return;
    setAuditLogRequest({ ...auditLogRequest, operation: "" });
    await getAuditLogs(auditLogRequest, "", "");
    setActiveTab("userLogsList");
  };

  const getFileUploadLogs = async (e) => {
    e.preventDefault();
    if (!validateDates()) return;
    setAuditLogRequest({ ...auditLogRequest, operation: "Upload" });
    await getAuditLogs(auditLogRequest, "Upload", "");
    setActiveTab("fileUploadLogsList");
  };

  useEffect(() => {
    console.log("Loading state changed:", isLoading);
  }, [isLoading]);
  return (
    <div id="userLogs">
      <div className="row">
        <div className="col-md-6">
          <div className="row">
            <div className="col-md-6">
              <div className="form-group">
                <label>Start Date</label>
                <DatePicker
                  selected={
                    auditLogRequest.fromDate
                      ? parse(
                          auditLogRequest.fromDate,
                          "yyyy-MM-dd",
                          new Date()
                        )
                      : null
                  }
                  onChange={(date) => {
                    setAuditLogRequest({
                      ...auditLogRequest,
                      fromDate: date ? format(date, "yyyy-MM-dd") : null,
                    });
                  }}
                  dateFormat="MM-dd-yyyy"
                  className="form-control"
                  placeholderText="MM-DD-YYYY"
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="form-group">
                <label>End Date</label>
                <DatePicker
                  selected={
                    auditLogRequest.toDate
                      ? parse(auditLogRequest.toDate, "yyyy-MM-dd", new Date())
                      : null
                  }
                  onChange={(date) => {
                    setAuditLogRequest({
                      ...auditLogRequest,
                      toDate: date ? format(date, "yyyy-MM-dd") : null,
                    });
                  }}
                  dateFormat="MM-dd-yyyy"
                  className="form-control"
                  placeholderText="MM-DD-YYYY"
                />
              </div>
            </div>
          </div>
          {error1 && (
            <div className="row">
              <div className="col-md-12">
                <p style={{ color: "red" }}>{error1}</p>
              </div>
            </div>
          )}
          <div className="row">
            <div className="col-md-12">
              <button
                type="submit"
                className="btn saveBtn mt-3 mb-3"
                onClick={getUserLogs}
              >
                User Logs
              </button>
              <button
                type="submit"
                className="btn saveBtn mt-3 mb-3"
                style={{ marginLeft: "10px" }}
                onClick={getFileUploadLogs}
              >
                File Upload Logs
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-md-12">
          {activeTab === "userLogsList" && (
            <UserLogsList
              auditLogs={auditLogs}
              isLoading={isLoading}
            ></UserLogsList>
          )}
          {activeTab === "fileUploadLogsList" && (
            <FileUploadLogsList
              auditLogs={auditLogs}
              isLoading={isLoading}
            ></FileUploadLogsList>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserLogs;
